const ToolboxInfo = {
  maxInstances: {
    show_image_block: 3,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "show_image_block",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
